export enum ProcedureTypeEnum {
	None = 0, // what is null in mat db comes as 0 from eupapi to us
	OrthoModelICast = 1,
	InvisalignAligners = 2,
	InvisalignFirstAligners = 3,
	InvisalignFirstPalatalExpander = 4,
	ViveraRetainer = 5,
	InvisalignRetainer = 6,
	NightGuard = 7,
	BiteSplint = 8,
	SportsMouthGuard = 9,
	ApneaSleepAppliance = 10,
	ClearAligners = 11,
	OrthoAppliance = 12,
	SurgicalGuideToothSupported = 13,
	SurgicalGuideTissueSupported = 14,
	SurgicalGuideBoneSupported = 15,
	FixedRestorativeHidden = 16,
	PartialDentureFramework = 17,
	ImmediateDenture = 18,
	FullDentureTissueBased = 19,
	FullDentureImplantBased = 20,
	SurgicalPlanningOnlyNoGuide = 21,
	FullImmediateDenture = 22,
	PartialDentureAcrylic = 23
}
